import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=c6fcfcfa"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=c6fcfcfa&prod&lang=scss"
import style1 from "./Registration.vue?vue&type=style&index=1&id=c6fcfcfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports